import type { Resource } from '../../';
export const language_it: Resource = {"default":"Italian"};
